import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GasNotificationService } from '../gas-notify.service';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=691%3A640 */
@Component({
  selector: 'gas-notify-wrapper',
  templateUrl: './gas-notify-wrapper.component.html',
  styleUrls: ['./gas-notify-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasNotifyWrapperComponent {
  public notifications$ = this.gasNotificationService.notifications$;

  public toastNotifications$ = this.gasNotificationService.toastNotifications$;

  constructor(
    private gasNotificationService: GasNotificationService,
  ) {}
}
